import transformKeyCase from 'Utils/transformKeyCase';
import { type AnyObject } from '@Types';
import {
    type LessonProgress,
    type ProjectProgress,
    type StreamProgress,
    type GetAllProgressResponse,
    type useContentProgressResponse,
} from '../ContentProgress.types';

export function convertGetAllProgressResponse(
    iguanaFormattedResponse: GetAllProgressResponse,
): useContentProgressResponse {
    const streamProgress = iguanaFormattedResponse.streamProgress.map(r =>
        transformKeyCase<StreamProgress>(r.asJson(), { to: 'camelCase' }),
    );
    const lessonProgress = iguanaFormattedResponse.lessonProgress.map(r =>
        transformKeyCase<LessonProgress>(r.asJson(), { to: 'camelCase' }),
    );
    const projectProgress = iguanaFormattedResponse.projectProgress.map(r =>
        transformKeyCase<ProjectProgress>(r, { to: 'camelCase' }),
    );
    const streamProgressByLocalePackId = streamProgress.reduce<AnyObject<StreamProgress>>((acc, curr) => {
        acc[curr.localePackId] = curr;
        return acc;
    }, {});
    const lessonProgressByLocalePackId = lessonProgress.reduce<AnyObject<LessonProgress>>((acc, curr) => {
        acc[curr.localePackId] = curr;
        return acc;
    }, {});
    const projectProgressByRequirementIdentifier = projectProgress.reduce<AnyObject<ProjectProgress>>((acc, curr) => {
        acc[curr.requirementIdentifier] = curr;
        return acc;
    }, {});

    return {
        streamProgress,
        lessonProgress,
        projectProgress,
        streamProgressByLocalePackId,
        lessonProgressByLocalePackId,
        projectProgressByRequirementIdentifier,
    };
}
